<template>
  <div name="list" class="shows">
    <div class="header">
      <img class="logo" src="assets/logo.gif">
      <div class="contact">
        Heavy Guitar Shows Since 2016
        <br>Bern - Switzerland
        <br>
        <span style="font-weight: bold;">contact@riot.fm</span>
        <br>
      </div>
    </div>

    <h1 class="title">Next Shows</h1>
    <div v-if="shows.length > 0">
      <div class="columns is-multiline is-centered" id="shows_list">
        <div v-for="show in shows" :key="show.date" class="column show_entry is-one-third">
          <div class="date_label">{{show.dateString}}</div>
          <img :src="backend + '/flyers/' + show.flyer">
          <br>
          <div v-for="band in show.bands" :key="band.name" class="band">
            <a v-bind:href="band.website">
              <div class="band_label glitch" v-bind:data-text="band.name">{{band.name}}</div>
            </a>
            <div class="genre_label">({{band.genres}} / {{band.country}})</div>
          </div>

          <div class="venue">
            <div class="venue_label">
              <a class="venue_link" v-bind:href="show.venue.website">{{show.venue.name}}</a>
              <br>
              {{show.venue.address}}, {{show.venue.city}}
            </div>
            <br>
          </div>

        </div>
      </div>
    </div>
    <div v-else style="text-align:center;">No upcoming events. Please come back later...</div>

    <h1 class="title">Past Shows</h1>
    <div id="past_shows" class="columns is-multiline is-centered">
      <div v-for="show in pastShows" :key="show.date" class="show_entry column is-one-third">
        <div class="date_label">{{show.dateString}}</div>
        <img class="flyer_past" :src="backend + '/flyers/' + show.flyer">
        <br>
        <div v-for="band in show.bands" :key="band.name" class="band">
          <a v-bind:href="band.website">
            <div class="band_label glitch" v-bind:data-text="band.name">{{band.name}}</div>
          </a>
          <div class="genre_label">{{band.genres}} / {{band.country}}</div>
        </div>

        <div class="venue">
          <div class="venue_label">
            <b>
              <a class="venue_link" v-bind:href="show.venue.website">{{show.venue.name}}</a>
            </b>
            <br>
            {{show.venue.address}}, {{show.venue.city}}
          </div>
          <br>
        </div>
      </div>
    </div>

    <div class="footer">
      <div>
        Photos by
        <b>
          <a href="https://www.flickr.com/photos/803/albums">803</a>
        </b> &
        <b>
          <a href="https://www.facebook.com/makesfa/">Makesfa</a>
        </b>
      </div>
      <div style="vertical-align: center;">
        <a href="https://youtu.be/4ruxmfXoUCE">
          <img style="width: 75px; height: 75px;" src="assets/gnwp.png">
        </a>
        <a href="http://historyisaweapon.com/defcon1/riotgrrrlmanifesto.html">
          <img style="width: 175px; height: 75px;" src="assets/grrrl.png">
        </a>
        <a href="http://cafete.ch">
          <img style="width: 100px; height: 70px; margin-right: 10px;" src="assets/cafete.png">
        </a>
        <a href="https://youtu.be/yy-SiZSlmhI">
          <img style="width: 75px; height: 75px;" src="assets/gnar.png">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  name: "Public",
  data() {
    return {
      shows: [],
      pastShows: [],
      backend: this.$backend
    };
  },
  mounted() {
    axios
      .get(this.$backend + "/api/events")
      .then(response => (this.shows = response.data));

    axios
      .get(this.$backend + "/api/events?past=true")
      .then(response => (this.pastShows = response.data));
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/glitch.scss";

img {
  width: 250px;
  height: 353px;
}

.media_vid {
  margin-top: 16px;
  width: 250px;
}

.venue {
  line-height: 1.2;
  margin-top: 2em;
}

.venue_label {
  font-family: "Roboto", sans-serif;
}

.venue_link:hover {
  color: white;
}

.band {
  margin-bottom: 8px;
  margin-top: 8px;
}

.genre_label {
  font-size: small;
  line-height: 0.75em;
  font-family: "Roboto", sans-serif;
}

.date_label {
  font-family: "Oswald", sans-serif;
  color: white;
  font-size: 125%;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.title {
  text-align: center;
  color: white;
  padding-top: 24px;
  font-size: 3em;
}

.band_label {
  font-size: 150%;
  color: white;
  font-family: "Anton", sans-serif;
}

.show_entry {
  width: fit-content;
  min-width: 250px;
  min-height: 350px;
  margin: 8px;
  background: #0d0d0d;
  border-top: solid gray 2px;
}

.flyer_past {
  -webkit-filter: grayscale(40%); /* Safari 6.0 - 9.0 */
  filter: grayscale(40%);
}

ul {
  list-style-type: none;
  background: black;
  width: fit-content;
  padding-left: 18px;
  padding-right: 18px;
}

.shows {
  background: rgba(6, 6, 6, 0.333);
  padding: 39.9px;
  box-shadow: 0 0 33px 66px rgba(6, 6, 6, 0.66);
}

.logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 220px;
  width: 220px;
}

.contact {
  text-align: center;
  color: white;
  margin-top: 16px;
}

.header {
  background: #0d0d0d;
  width: 270px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  padding-bottom: 16px;
}

.footer {
  text-align: center;
  background: transparent;
}
</style>
